import { useState } from 'react'

interface UseClientSearchProps {
    onClientSelect: (clientId: string, petIndex?: number) => void
    redirectPath: string
    requirePetSelection?: boolean
}

export function useClientSearch({ onClientSelect, redirectPath, requirePetSelection = false }: UseClientSearchProps) {
    const [isOpen, setIsOpen] = useState(false)

    const handleOpen = () => setIsOpen(true)
    const handleClose = () => setIsOpen(false)

    const handleClientSelect = (clientId: string, petIndex?: number) => {
        onClientSelect(clientId, petIndex)
        handleClose()
    }

    return {
        isOpen,
        handleOpen,
        handleClose,
        handleClientSelect,
        redirectPath,
        requirePetSelection,
    }
}
